module.exports = __webpack_public_path__ + "img/icon-close-dark_3c09c.png";